function MediaVideoIcon({
  size = 36,
  className = '',
  onClick = (event) => {}
}: {
  size?: number;
  className?: string;
  onClick?: (event) => void;
}) {
  return (
    <span className={className} onClick={onClick}>
      <svg
        xmlns='http://www.w3.org/2000/svg'
        width={size}
        height={(size * 32) / 33}
        viewBox='0 0 33 32'
        fill='currentColor'
      >
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M25.5 6H7.5C6.39543 6 5.5 6.89543 5.5 8V26C5.5 27.1046 6.39543 28 7.5 28H25.5C26.6046 28 27.5 27.1046 27.5 26V8C27.5 6.89543 26.6046 6 25.5 6ZM7.5 4C5.29086 4 3.5 5.79086 3.5 8V26C3.5 28.2091 5.29086 30 7.5 30H25.5C27.7091 30 29.5 28.2091 29.5 26V8C29.5 5.79086 27.7091 4 25.5 4H7.5Z'
        />
        <path fillRule='evenodd' clipRule='evenodd' d='M9.5 29L9.5 5L11.5 5L11.5 29L9.5 29Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M5.5 16L29.5 16L29.5 18L5.5 18L5.5 16Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M5.5 10H10.5V12H5.5V10Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M5.5 22H10.5V24H5.5V22Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M23.5 10H28.5V12H23.5V10Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M23.5 22H28.5V24H23.5V22Z' />
        <path fillRule='evenodd' clipRule='evenodd' d='M21.5 29L21.5 5L23.5 5L23.5 29L21.5 29Z' />
      </svg>
    </span>
  );
}

export default MediaVideoIcon;
